// extracted by mini-css-extract-plugin
export default {"zoom2":"ZonasListComponent_zoom2__wULeT","botonItemZona":"ZonasListComponent_botonItemZona__eyk8q","alertItem":"ZonasListComponent_alertItem__m2CRe"};